import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { restoreBackupFromFile } from "../redux/actions/backupRestoreActions";
import { Label } from "@atlaskit/form";
import Button from "@atlaskit/button/new";
import SectionMessage from "@atlaskit/section-message";

function RestoreFlowFromFile() {
  const dispatch = useDispatch();
  const [fileContent, setFileContent] = useState(null);
  const [fileSelected, setFileSelected] = useState(false);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) {
      setFileSelected(false);
      return;
    }
    setFileSelected(true);

    const reader = new FileReader();

    reader.onload = (event) => {
      setFileContent(event.target.result);
    };

    reader.onerror = (error) => {
      console.error("Error reading file:", error);
    };

    reader.readAsText(file); // You can use readAsDataURL or readAsArrayBuffer depending on file type
  };

  const handleRestore = () => {
    if (fileContent) {
      dispatch(restoreBackupFromFile(fileContent));
    }
  };

  return (
    <div>
      <Label>Select the backup file to restore the integration</Label>
      <SectionMessage title="Usage note">
        Select a backup file and press Restore to start the restore process. <br /> Backup files can be downloaded from the table below.
      </SectionMessage>

      <br />
      <input type="file" onChange={handleFileChange} accept=".txt,.json" />
      <p />
      <Button onClick={handleRestore} isDisabled={!fileSelected}>
        Restore
      </Button>
    </div>
  );
}

export default RestoreFlowFromFile;
